import React, { Component } from "react";
import {toast} from 'react-toastify';
import Application from "shared/containers/application";
import HomeLayout from "../../home/components/home-layout";
import { apiFetch } from "apiFetch";

class Home extends Component {
  state = {
    plans: [],
    paymentMethods: [],
    showPaymentDetails: {},
    visibility: {},
    docsToSign: null,
    achNeedsVerification: []
  };

  componentDidMount() {
    this.loadHomeData();
  }

  loadHomeData = async () => {
    let docsToSign = null;
    let achNeedsVerification = [];
    try {
      const paymentDetails = await apiFetch("/api/paymentDetails", {
        method: "GET"
      });

      const activePlans = paymentDetails.filter(plan => plan["status"] === "active");
      if (activePlans.length > 0) {
        const responses = await Promise.all([
          apiFetch("/api/documents?doctype=toSign", {
            method: "GET"
          }),
          apiFetch("/api/user/bank_verification", {
            method: "GET",
          })
        ]);

        docsToSign = responses[0].data;
        achNeedsVerification = responses[1].ach_needs_verify;
      }

      this.setState({
        plans: paymentDetails,
        activePlans: paymentDetails.filter(plan => plan["status"] === "active"),
        completedPlans: paymentDetails.filter(plan => plan["status"] === "paid"),
        canceledPlans: paymentDetails.filter(plan => plan["status"] === "cancelled"),
        defaultedPlans: paymentDetails.filter(plan => plan["status"] === "default"),
        docsToSign: docsToSign && docsToSign.urls.length ? docsToSign: null,
        achNeedsVerification
      });

    } catch (e) {
      console.log(e);
      if (e !== 'Unauthorized') {
        toast.error('An error occured, please try again.');
      }
    }
  };

  handleClickArrow = paymentId => {
    this.setState({
      showPaymentDetails: {
        [paymentId]: !this.state.showPaymentDetails[paymentId]
      }
    });
  };

  render() {
    return (
      <Application
        hideAchMessage={this.state.hideAchMessage}
        loadHomeData={this.loadHomeData}
      >
        <HomeLayout
          {...this.state}
          {...this.props}
          handleClickArrow={this.handleClickArrow}
        />
      </Application>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/containers/home.js